var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-clickbutton"},[_c('button',{staticClass:"c-clickbutton-button",attrs:{"disabled":_vm.model.disabled},on:{"click":_vm.click}},[_vm._v(_vm._s(_vm.model.disabled ? _vm.labelDisabled : _vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }